var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "markets-ui-popover",
    {
      class: _vm.namespace(),
      attrs: {
        customClass: _vm.customClass,
        namespaced: _vm.namespaced,
        visible: _vm.visible,
        target: _vm.target,
        width: _vm.width,
        skin: _vm.skin
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.tipsMsg) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }